import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Desktop from './components/Desktop';
import AdminPanel from './components/admin/AdminPanel';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Desktop />} />
        <Route path="/admin/*" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
};

export default App;
